import React, { useState, useEffect } from 'react';
import api from './api';
import Connexion from './Connexion';
import Veille from './Veille';
import Comparatif from './Comparatif';
import Relances from './commercial/Relances';
import Comptes from './commercial/Comptes';
import Fiche from './commercial/Fiche';
import Nouveau from './commercial/Nouveau';
import TableauDeBord from './commercial/TableauDeBord';
import Utilisateurs from './commercial/Utilisateurs';
import MotDePasse from './MotDePasse';
import { useRoute, Icone } from './commercial/commun';

const NAV = [
  { cle: 'relances', libelle: 'Mes relances' },
  { cle: 'comptes', libelle: 'Comptes', aussi: ['compte', 'nouveau'] },
  { cle: 'tableau', libelle: 'Tableau de bord' },
  { cle: 'veille', libelle: 'Veille prix' },
  { cle: 'comparatif', libelle: 'Comparatif' },
];

export default function App() {
  const [utilisateur, setUtilisateur] = useState(null);
  const [charge, setCharge] = useState(false);
  const [referentiel, setReferentiel] = useState(null);
  const { segments, params } = useRoute();
  const page = segments[0] || 'relances';

  useEffect(() => {
    if (!localStorage.getItem('a97vin-token')) { setCharge(true); return; }
    api.get('/auth/moi')
      .then((r) => setUtilisateur(r.data.utilisateur))
      .catch(() => localStorage.removeItem('a97vin-token'))
      .finally(() => setCharge(true));
  }, []);
  useEffect(() => {
    if (utilisateur) api.get('/commercial/referentiel').then((r) => setReferentiel(r.data)).catch(() => {});
  }, [utilisateur]);

  const deconnecter = () => { localStorage.removeItem('a97vin-token'); setUtilisateur(null); };

  if (!charge) return <div className="attente">Chargement…</div>;
  if (!utilisateur) return <Connexion onConnecte={setUtilisateur} />;
  // Mot de passe fixé par un administrateur : à remplacer avant tout le reste.
  if (utilisateur.mdp_a_changer) {
    return <MotDePasse obligatoire onDeconnecter={deconnecter}
      onTermine={() => setUtilisateur({ ...utilisateur, mdp_a_changer: false })} />;
  }

  const estAdmin = utilisateur.role === 'admin';
  const actif = (n) => page === n.cle || (n.aussi || []).includes(page);
  const nav = estAdmin ? NAV.concat([{ cle: 'utilisateurs', libelle: 'Utilisateurs' }]) : NAV;
  const props = { utilisateur, referentiel, params };

  let contenu;
  switch (page) {
    case 'comptes': contenu = <Comptes {...props} />; break;
    case 'compte': contenu = <Fiche key={segments[1]} id={segments[1]} {...props} />; break;
    case 'nouveau': contenu = <Nouveau {...props} />; break;
    case 'tableau': contenu = <TableauDeBord {...props} />; break;
    case 'veille': contenu = <Veille utilisateur={utilisateur} />; break;
    case 'comparatif': contenu = <Comparatif />; break;
    case 'utilisateurs': contenu = estAdmin ? <Utilisateurs {...props} /> : null; break;
    case 'mot-de-passe': contenu = <MotDePasse />; break;
    default: contenu = <Relances {...props} />;
  }

  return (
    <div className="appli">
      <header>
        <a href="#/relances" className="marque logotype" aria-label="A97 Vin, accueil"><span className="a">A</span><span className="n">97</span><span className="app">VIN</span></a>
        <nav className="nav-principale" aria-label="Navigation principale">
          {nav.map((n) => <a key={n.cle} href={`#/${n.cle}`} className={actif(n) ? 'actif' : ''} aria-current={actif(n) ? 'page' : undefined}>{n.libelle}</a>)}
        </nav>
        <span className="pousse" />
        <a href="#/mot-de-passe" className="qui" title="Mon mot de passe">{utilisateur.nom || utilisateur.identifiant}{utilisateur.societe_nom ? ` · ${utilisateur.societe_nom}` : ''}</a>
        {/* Sur téléphone, le nom est masqué : un lien court le remplace. */}
        <a href="#/mot-de-passe" className="lien-mdp-mobile">Mot de passe</a>
        <button className="lien" onClick={deconnecter}>Déconnexion</button>
      </header>
      <main>{contenu}</main>
      <nav className="barre-mobile" aria-label="Navigation">
        <a href="#/relances" className={page === 'relances' ? 'actif' : ''}><Icone.Coche taille={22} />Relances</a>
        <a href="#/comptes" className={['comptes', 'compte'].includes(page) ? 'actif' : ''}><Icone.Liste taille={22} />Comptes</a>
        <a href="#/nouveau" className="bouton-rond" aria-label="Nouveau prospect"><Icone.Plus taille={26} /></a>
        <a href="#/tableau" className={page === 'tableau' ? 'actif' : ''}><Icone.Graphe taille={22} />Tableau</a>
        <a href="#/veille" className={['veille', 'comparatif'].includes(page) ? 'actif' : ''}><Icone.Loupe taille={22} />Veille</a>
      </nav>
    </div>
  );
}
